import React, { useState, useEffect } from "react";
import "./CookieBanner.scss";
import WhiteButton from "../WhiteButton/WhiteButton";

const CookieBanner = (props) => {
  const [preferences, setPreferences] = useState({
    necessary: true,
    preferences: true,
    statistics: true,
    marketing: true,
  });

  const savePreferences = () => {
    localStorage.setItem("cookieConsent", JSON.stringify(preferences));
    props.setVisibility(false);
  };

  const handleCheckboxChange = (event) => {
    setPreferences({
      ...preferences,
      [event.target.name]: event.target.checked,
    });
  };

  useEffect(() => {
    const consent = JSON.parse(localStorage.getItem("cookieConsent"));
    if (!consent) {
      props.setVisibility(true);
    } else {
      setPreferences(consent);
      props.setVisibility(false);
    }
  }, []);

  if (!props.isVisible) {
    return null;
  }

  return (
    <div className="cookie-banner">
      <h2>Our Cookie Policy</h2>
      <p>
        We use cookies to give you the best experience possible. Please indicate
        your preferences:
      </p>
      <div>
        <input
          type="checkbox"
          id="necessary"
          name="necessary"
          checked={preferences.necessary}
          disabled
        />
        <label htmlFor="necessary">Necessary Cookies (Always enabled)</label>
      </div>
      <div>
        <input
          type="checkbox"
          id="preferences"
          name="preferences"
          checked={preferences.preferences}
          onChange={handleCheckboxChange}
        />
        <label htmlFor="preferences">Preferences Cookies</label>
      </div>
      <div>
        <input
          type="checkbox"
          id="statistics"
          name="statistics"
          checked={preferences.statistics}
          onChange={handleCheckboxChange}
        />
        <label htmlFor="statistics">Statistics Cookies</label>
      </div>
      <div>
        <input
          type="checkbox"
          id="marketing"
          name="marketing"
          checked={preferences.marketing}
          onChange={handleCheckboxChange}
        />
        <label htmlFor="marketing">Marketing Cookies</label>
      </div>
      <WhiteButton
        onClick={savePreferences}
        text={"Save Preferences"}
        hoverColor="#622be2"
        style={{
          fontSize: "16px",
          marginTop: "10px",
          height: "30px",
        }}></WhiteButton>
    </div>
  );
};

export default CookieBanner;
